export const getContainerFactoryStyles = () =>
  ({
    Container: {
      width: '100%',
      border: '1px solid #605E5C',
      padding: '10px',
      boxSizing: 'border-box',
      display: 'flex',
    },
    InVisible: {
      display: 'none',
    },
    ContentContainer: {
      flex: 1,
    },
    EditButton: {
      outline: 'none',
      color: 'rgb(0, 120, 212)',
      '&:hover': {
        textDecoration: 'underline',
        cursor: 'pointer',
      },
    },
  });
